import { endpoints, apiVersion } from "./endpoints";
import apiRequest from "./apiConfig";

export function downloadParkingBayTemplateApi() {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.parkingBay + endpoints.template,
    responseType: 'arraybuffer'
  })
}

export function downloadShiftTemplateApi() {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.shift + endpoints.template,
    responseType: 'arraybuffer'
  })
}

export function downloadCrewmemberTemplateApi() {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.template,
    responseType: 'arraybuffer'
  })
}

export function downloadAmbulanceTemplateApi() {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulance + endpoints.template,
    responseType: 'arraybuffer'
  })
}

export function importTemplateApi(endpoint, payload) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoint + endpoints.import,
    method: "post",
    payload,
    type: 'formData'
  })
}